import { HTTPError } from '@salesforce/pwa-kit-react-sdk/ssr/universal/errors';
import type { BFFHttpError } from '../bff-api/model/BFFHttpError';
import type { CommerceResponseBody } from '../bff-api/model/CommerceResponseBody';
import type { PwaError } from '../components/_error/interfaces/PwaError';

export const buildHttpError = ({ status, body, message, stack }: BFFHttpError): HTTPError => {
    // Using HTTPError because it is checked by logAndFormatError function by
    // node_modules\@salesforce\pwa-kit-react-sdk\ssr\server\react-rendering.js
    const httpError = new HTTPError(status, body ? JSON.stringify(body) : message);

    if (stack) {
        httpError.stack = stack;
    }

    return httpError;
};

export const buildPwaError = (error: PwaError): PwaError => {
    const { status, stack } = error;
    let { body, message } = error;

    if (!body && typeof message === 'string') {
        try {
            const commerceBody = JSON.parse(message) as CommerceResponseBody;
            body = commerceBody;

            if (commerceBody.statusMessage) {
                message = commerceBody.statusMessage;
            } else if (commerceBody.detail) {
                message = commerceBody.detail;
            } else {
                message = undefined;
            }
        } catch (err) {
            // Ignore to keep original values.
        }
    }

    return {
        status,
        stack,
        message,
        body,
    };
};

export const buildCommerceResponseBody = (error: unknown): CommerceResponseBody | null => {
    if (error && typeof error === 'object' && 'body' in error) {
        try {
            return error.body as CommerceResponseBody;
        } catch (err) {
            // Ignore because it is not a CommerceResponseBody
        }
    }

    return null;
};
